import { Injectable } from '@angular/core';
import { DetailsConfigField } from 'app/entities';

/**
 * Serviço para gerenciar a persistência da configuração global de exibição
 * de detalhes de produtos/serviços no Local Storage
 */
@Injectable({
  providedIn: 'root'
})
export class DetailsConfigStorageService {
  DETAILS_CONFIG_STORAGE_KEY = 'last_details_config';
  constructor() { }

  /**
   * Salva a configuração global no Local Storage
   * @param config Configuração a ser salva (apenas valores boolean)
   */
  saveGlobalConfig(config: DetailsConfigField[]): void {
    try {
      
      localStorage.setItem(this.DETAILS_CONFIG_STORAGE_KEY, JSON.stringify(config));
      
    } catch (error) {
      console.error('[DetailsConfigStorage] ❌ Erro ao salvar configuração no Local Storage:', error);
    }
  }

  /**
   * Recupera a configuração global do Local Storage
   * @returns Configuração salva ou objeto vazio se não existir
   */
  getGlobalConfig(): DetailsConfigField[] {
    try {
      
      const stored = localStorage.getItem(this.DETAILS_CONFIG_STORAGE_KEY);
      
      if (stored) {
        const parsed = JSON.parse(stored);
        return parsed;
      }
    } catch (error) {
      console.error('[DetailsConfigStorage] ❌ Erro ao recuperar configuração do Local Storage:', error);
    }
    
    // Retorna objeto vazio se não houver nada salvo ou ocorrer erro
    return [];
  }

  /**
   * Remove a configuração global do Local Storage
   */
  clearGlobalConfig(): void {
    try {
      localStorage.removeItem(this.DETAILS_CONFIG_STORAGE_KEY);
      
    } catch (error) {
      console.error('[DetailsConfigStorage] ❌ Erro ao limpar configuração do Local Storage:', error);
    }
  }

  /**
   * Verifica se existe uma configuração salva
   * @returns true se existe configuração salva
   */
  hasStoredConfig(): boolean {
    try {
      const hasConfig = localStorage.getItem(this.DETAILS_CONFIG_STORAGE_KEY) !== null;
      return hasConfig;
    } catch (error) {
      console.error('[DetailsConfigStorage] ❌ Erro ao verificar configuração:', error);
      return false;
    }
  }
}
